<template>
  <div class="feature-details">
    <div v-if="selected_feature" class="quick-details">
      <div class="card">
        <div class="card-header" style="flex-direction: column">
          <div class="card-header-title">
            <div>
              <img
                src="@/assets/icons/point.png"
                v-if="
                  selected_feature && selected_feature.geometry.type === 'Point'
                "
              />
              <svg v-else viewBox="0 0 100 100" class="image is-48x48 mr-10">
                <use
                  v-if="
                    selected_feature &&
                    selected_feature.geometry.type === 'Polygon'
                  "
                  xlink:href="@/assets/icons/sprite.svg#polygon"
                />
                <use
                  v-else-if="
                    selected_feature &&
                    selected_feature.geometry.type === 'LineString'
                  "
                  xlink:href="@/assets/icons/sprite.svg#line"
                />
                <use xlink:href="@/assets/icons/sprite.svg#point" />
              </svg>
            </div>
            <div>
              <p
                v-tooltip="selected_feature.properties.name || 'NA'"
                style="margin-left: 7px"
                class="is-size-7"
                :title="selected_feature.properties.name"
              >
                {{ selected_feature.properties.name || "NA" | truncate(20) }}
              </p>
              <div
                class="button is-small"
                style="border: 0"
                v-if="feature_type(selected_feature.properties.featureType)"
              >
                <span class="icon">
                  <i
                    :style="{
                      color: feature_type(
                        selected_feature.properties.featureType
                      ).properties.color,
                    }"
                    class="fas fa-circle mr-5"
                  ></i>
                </span>
                <span>{{
                  feature_type(selected_feature.properties.featureType).name
                }}</span>
              </div>
            </div>
          </div>
          <div class="card-header-title">
            <!-- <div style="margin-right:1rem">
              <p>{{localization('app-project','Project')}}</p>
              <p class="tag">Construction project {hardcoded}</p>
            </div>-->
            <div>
              <template v-if="selected_feature.geometry.type === 'Polygon'">
                {{ localization("app-area", "Area") }}
                <p class="is-size-7 has-text-grey">
                  {{ selected_feature_area.toFixed(4) }} acres
                  <!-- m <sup>2</sup> -->
                </p>
              </template>
              <template v-if="selected_feature.geometry.type === 'LineString'">
                Length
                <p class="is-size-7 has-text-grey">
                  {{ (selected_feature_length * 1000).toFixed(3) }} m
                </p>
              </template>
            </div>
          </div>
        </div>
        <!-- strategix4_details -->
        <span
          class="has-text-grey is-size-7"
          style="padding: 10px; font-weight: 700"
          v-if="is_loading_strategix4"
        >
          Loading...
        </span>
        <div
          v-else
          class="is-flex is-size-7"
          style="padding: 4px 10px; font-weight: 700; flex-flow: wrap;"
        >
          <div
            v-if="strategix4_details.string_pr.value !== null"
            style="flex: 0 50%"
          >
            {{ strategix4_details.string_pr.label }}
            <p class="has-text-grey">
              {{ strategix4_details.string_pr.value.toFixed(2) }}
            </p>
          </div>
          <div
            style="flex: 0 50%"
            v-if="strategix4_details.avg_string_pr.value !== null"
          >
            {{ strategix4_details.avg_string_pr.label }}
            <p class="has-text-grey">
              {{ strategix4_details.avg_string_pr.value.toFixed(2) }}
            </p>
          </div>
          <div
            v-if="strategix4_details.current.value !== null"
            style="flex: 0 50%"
          >
            {{ strategix4_details.current.label }}
            <p class="has-text-grey">
              {{ strategix4_details.current.value.toFixed(2) }}
            </p>
          </div>
          <div
            style="flex: 0 50%"
            v-if="strategix4_details.voltage.value !== null"
          >
            {{ strategix4_details.voltage.label }}
            <p class="has-text-grey">
              {{ strategix4_details.voltage.value.toFixed(2) }}
            </p>
          </div>
        </div>
        <!-- strategix4_details -->

        <div
          class="card-content has-slimscroll-xs"
          style="padding: 0.5rem; height: 100px; overflow: scroll"
          v-if="
            selected_feature.properties.extraProperties &&
            Object.values(selected_feature.properties.extraProperties).length
          "
        >
          <table class="table is-fullwidth">
            <tbody>
              <tr
                v-for="(value, key) of selected_feature.properties
                  .extraProperties"
                :key="key"
              >
                <th>{{ headerCase(key) }}</th>
                <th v-if="key[0] !== '_'">
                  <span
                    style="max-width: 270px; display: block"
                    v-tooltip="value"
                    v-linkified
                    v-html="sanitize(value)"
                  ></span>
                </th>
                <th v-else>
                  <a
                    @click="
                      key == '_serial_numbers' &&
                        $root.$emit('show_serial_number_table', value)
                    "
                    >{{ localization("app-show-details", "Show details") }}
                  </a>
                </th>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <b-modal :active.sync="isActive" :width="600" scroll="keep">
      <div class="card" style="border-radius: 10px">
        <div class="card-header">
          <h2 class="card-header-title is-size-6">
            {{ localization("app-name", "Name") }} :
            {{
              (active_feature &&
                active_feature.properties &&
                active_feature.properties.name) ||
              localization("app-not-available", "Not Available")
            }}
          </h2>
        </div>
        <div class="card-content" style="padding: 0; padding-bottom: 1rem">
          <div class="table-isresponsive">
            <table
              style="margin: 0"
              class="
                is-responsive is-fullwidth
                table-centered
                is-size-6
                table
                is-bordered is-striped
              "
            >
              <thead>
                <tr class="has-text-centered">
                  <td rowspan="3" colspan="2">
                    {{ localization("app-project-name", "Project Name") }}
                  </td>
                  <td colspan="9">
                    {{ localization("app-volume", "Volume") }}
                  </td>
                </tr>
                <tr>
                  <td colspan="3">
                    {{ localization("app-base-height", "Base-Height") }}
                  </td>
                  <td colspan="3">
                    {{ localization("app-triangulated", "Triangulated") }}
                  </td>
                  <td colspan="3">
                    {{
                      localization(
                        "app-surface-to-surface",
                        "Surface to Surface"
                      )
                    }}
                  </td>
                </tr>
                <tr class="is-uppercase is-size-7">
                  <td>{{ localization("app-cut", "cut") }}</td>
                  <td>{{ localization("app-fill", "fill") }}</td>
                  <td>{{ localization("app-total", "total") }}</td>
                  <td>{{ localization("app-cut", "cut") }}</td>
                  <td>{{ localization("app-fill", "fill") }}</td>
                  <td>{{ localization("app-total", "total") }}</td>
                  <td>{{ localization("app-cut", "cut") }}</td>
                  <td>{{ localization("app-fill", "fill") }}</td>
                  <td>{{ localization("app-total", "total") }}</td>
                </tr>
              </thead>
              <tbody>
                <template v-for="(feature, i) in master_uid_data">
                  <template>
                    <tr
                      :key="i * 7"
                      class="is-uppercase is-size-7"
                      :class="{
                        'has-text-info':
                          active_feature.properties.project ===
                          feature.properties.project,
                      }"
                    >
                      <td rowspan="3">
                        {{ get_project_name(feature).name || "" }}
                      </td>
                    </tr>
                    <tr
                      class="is-size-7"
                      :key="i * 7"
                      :class="{
                        'has-text-info':
                          active_feature.properties.project ===
                          feature.properties.project,
                      }"
                    >
                      <td class="is-uppercase">dsm</td>
                      <td>
                        {{
                          get_data(feature, "base-height", "dsm", "cut") || "-"
                        }}
                      </td>
                      <td>
                        {{
                          get_data(feature, "base-height", "dsm", "fill") || "-"
                        }}
                      </td>
                      <td>
                        {{
                          get_data(feature, "base-height", "dsm", "total") ||
                          "-"
                        }}
                      </td>
                      <td>
                        {{
                          get_data(feature, "triangulated", "dsm", "cut") || "-"
                        }}
                      </td>
                      <td>
                        {{
                          get_data(feature, "triangulated", "dsm", "fill") ||
                          "-"
                        }}
                      </td>
                      <td>
                        {{
                          get_data(feature, "triangulated", "dsm", "total") ||
                          "-"
                        }}
                      </td>
                      <td>
                        {{
                          get_data(
                            feature,
                            "surface-to-surface",
                            "dsm",
                            "cut"
                          ) || "-"
                        }}
                      </td>
                      <td>
                        {{
                          get_data(
                            feature,
                            "surface-to-surface",
                            "dsm",
                            "fill"
                          ) || "-"
                        }}
                      </td>
                      <td>
                        {{
                          get_data(
                            feature,
                            "surface-to-surface",
                            "dsm",
                            "total"
                          ) || "-"
                        }}
                      </td>
                    </tr>
                    <tr
                      class="is-size-7"
                      :key="i * 7"
                      :class="{
                        'has-text-info':
                          active_feature.properties.project ===
                          feature.properties.project,
                      }"
                    >
                      <td class="is-uppercase">dtm</td>
                      <td>
                        {{
                          get_data(feature, "base-height", "dtm", "cut") || "-"
                        }}
                      </td>
                      <td>
                        {{
                          get_data(feature, "base-height", "dtm", "fill") || "-"
                        }}
                      </td>
                      <td>
                        {{
                          get_data(feature, "base-height", "dtm", "total") ||
                          "-"
                        }}
                      </td>
                      <td>
                        {{
                          get_data(feature, "triangulated", "dtm", "cut") || "-"
                        }}
                      </td>
                      <td>
                        {{
                          get_data(feature, "triangulated", "dtm", "fill") ||
                          "-"
                        }}
                      </td>
                      <td>
                        {{
                          get_data(feature, "triangulated", "dtm", "total") ||
                          "-"
                        }}
                      </td>
                      <td>
                        {{
                          get_data(
                            feature,
                            "surface-to-surface",
                            "dtm",
                            "cut"
                          ) || "-"
                        }}
                      </td>
                      <td>
                        {{
                          get_data(
                            feature,
                            "surface-to-surface",
                            "dtm",
                            "fill"
                          ) || "-"
                        }}
                      </td>
                      <td>
                        {{
                          get_data(
                            feature,
                            "surface-to-surface",
                            "dtm",
                            "total"
                          ) || "-"
                        }}
                      </td>
                    </tr>
                  </template>
                  <template></template>
                </template>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapState } from "vuex";
import FeatureService from "@/services/feature.service";
import APIService from "@/services/api.service";
import _ from "lodash";
import base64 from "base-64";
import { sanitize } from "dompurify";
import { headerCase } from "change-case";
var moment = require("moment-timezone");


export default {
  data() {
    return {
      featureService: new FeatureService(),
      apiService: new APIService(),
      isActive: false,
      master_uid_data: null,
      active_feature: null,
      selected_feature: null,
      vault_count: 0,
      tickets_count: 0,
      is_loading: false,
      strategix4_details: {
        string_pr: { label: "String PR", value: 2.900011 },
        avg_string_pr: { label: "Avg. String PR", value: 3.1 },
        current: { label: "Current", value: 4.1 },
        voltage: { label: "Voltage", value: 5.1 },
      },
      is_loading_strategix4: false,
    };
  },
  computed: {
    ...mapState([
      "draw",
      "container",
      "map",
      "feature_type_groups",
      "active_project",
    ]),
    selected_feature_area() {
      if (!this.selected_feature) return "";
      return turf.area(this.draw.getSelected()) * 0.000247105;
    },
    selected_feature_length() {
      if (!this.selected_feature) return "";
      return turf.length(this.draw.getSelected());
    },
  },
  watch: {
    selected_feature() {
      this.get_strategix4_details();
    },
    map: function (val) {
      if (val) {
        this.map.on("click", (e) => {
          e = this.draw.getSelected();
          if (e.features.length == 1) {
            parent.postMessage({ name: "show_ebs_data", element: null }, "*");
            this.selected_feature = e.features[0];
            if (this.selected_feature.properties.element) {
              parent.postMessage(
                { name: "show_ebs_data", element: this.selected_feature },
                "*"
              );
              this.$root.$emit("sidebar_toggle");
            }
            // this.get_ebs_data();
          } else {
            parent.postMessage({ name: "show_ebs_data", element: null }, "*");
            this.$root.$emit("sidebar_toggle");
            this.selected_feature = null;
          }
        });
      }
    },
  },
  created() {
    document.addEventListener("click", (event) => {
      // save feature
      if (
        event.target.id == "feature-details" ||
        (event.target.parentNode &&
          event.target.parentNode.id == "feature-details")
      ) {
        this.isActive = true;
        let feature = this.draw.getSelected().features[0];
        this.active_feature = feature;
        this.featureService
          .get_master_uid_data({
            uid:
              feature.properties.hierarchyProperties &&
              feature.properties.hierarchyProperties.master_uid
                ? feature.properties.hierarchyProperties.master_uid
                : feature.properties.uid,
          })
          .then((res) => {
            this.master_uid_data = res.data.features;
          })
          .catch((err) => {
            this.handleErrors(err);
            console.log("Error");
          });
      }
    });
  },
  methods: {
    sanitize,
    async get_strategix4_details() {
      this.strategix4_details = {
        string_pr: { label: "String PR", value: null },
        avg_string_pr: { label: "Avg. String PR", value: null },
        current: { label: "Current", value: null },
        voltage: { label: "Voltage", value: null },
      };

      // sgx_avg_pr_days: "7"
      // sgx_poll_interval: "6"
      // sgx_project_id: "11"
      // sgx_timezone: "Asia/Bangkok"

      if (
        this.selected_feature &&
        this.active_project.properties.sgx_project_id
      ) {
        this.is_loading_strategix4 = true;
        try {
          let query = `no_token=true&no_org=true&token=${this.$store.state.strategix4_token}`;
          let promises = [];

          let timezone =
            this.active_project.properties.sgx_timezone || moment.tz.guess();

          promises.push(
            this.apiService.get_strategix4_data({
              body: {
                stream_name: "stringdata_5min",
                from_date: moment
                  .tz(timezone)
                  .subtract(
                    this.active_project.properties.sgx_poll_interval || 10,
                    "minutes"
                  )
                  .format("YYYY-MM-DD HH:mm:ss"),
                to_date: moment.tz(timezone).format("YYYY-MM-DD HH:mm:ss"),
                sort_order: "desc",
                select_columns: [
                  "dc_current",
                  "performance_ratio",
                  "timestamp",
                ],
                filter_criteria: {
                  project_id: this.active_project.properties.sgx_project_id,
                  equipment_name: this.selected_feature.properties.name,
                },
              },
              query,
            })
          );

          promises.push(
            this.apiService.get_strategix4_data({
              body: {
                stream_name: "stringdata_5min",
                from_date: moment
                  .tz(timezone)
                  .subtract(
                    this.active_project.properties.sgx_avg_pr_days || 7,
                    "days"
                  )
                  .format("YYYY-MM-DD HH:mm:ss"),
                to_date: moment.tz(timezone).format("YYYY-MM-DD HH:mm:ss"),
                sort_order: "desc",
                select_columns: ["performance_ratio", "timestamp"],
                filter_time: moment.tz(timezone).format("HH:00"),
                filter_criteria: {
                  project_id: this.active_project.properties.sgx_project_id,
                  equipment_name: this.selected_feature.properties.name,
                },
              },
              query,
            })
          );
          if (this.selected_feature.properties.extraProperties.inverter)
            promises.push(
              this.apiService.get_strategix4_data({
                body: {
                  stream_name: "pvdata",
                  from_date: moment
                    .tz(timezone)
                    .subtract(
                      this.active_project.properties.sgx_poll_interval || 6,
                      "minutes"
                    )
                    .format("YYYY-MM-DD HH:mm:ss"),
                  to_date: moment.tz(timezone).format("YYYY-MM-DD HH:mm:ss"),

                  sort_order: "desc",
                  select_columns: ["equipment_name", "timestamp", "dc_voltage"],
                  filter_criteria: {
                    project_id: this.active_project.properties.sgx_project_id,
                    equipment_name:
                      this.selected_feature.properties.extraProperties.inverter,
                  },
                },
                query,
              })
            );

          let data = await Promise.all(promises);

          if (data[0].data.length) {
            this.strategix4_details.string_pr.value =
              data[0].data[0].performance_ratio;
            this.strategix4_details.current.value = data[0].data[0].dc_current;
          }
          if (data[1].data.length) {
            this.strategix4_details.avg_string_pr.value =
              _.sumBy(data[1].data, "performance_ratio") / data[1].data.length;
          }
          if (data[2]) {
            this.strategix4_details.voltage.value = data[2].data[0].dc_voltage;
          }
          this.is_loading_strategix4 = false;
        } catch (err) {
          console.log(err);
          this.is_loading_strategix4 = false;
        }
      }
    },
    headerCase(key) {
      return headerCase(key);
    },
    truncateStr(name) {
      if (!name) return "";
      return _.truncate(name || "NA", {
        length: 20,
        separator: " ",
      });
    },
    feature_type(featureTypeUid) {
      let featureType = null;
      for (let i in this.feature_type_groups) {
        featureType = this.feature_type_groups[i].featureTypes.find(
          (ft) => ft.uid === featureTypeUid
        );
        if (featureType) break;
      }
      if (featureType) return featureType;
      return "";
    },
    get_project_name(feature) {
      if (
        feature.properties &&
        feature.properties.uid &&
        this.container &&
        this.container.groups &&
        this.container.groups.length
      ) {
        let project = null;
        for (let group of this.container.groups) {
          if (group.projects && group.projects.length)
            project = group.projects.find(
              (p) => p.uid === feature.properties.project
            );
          if (project) return { name: project.name, uid: project.uid };
        }
      }
      return {};
    },
    get_data(feature, type, layer, val_type) {
      if (
        !feature.properties.dataProperties ||
        !feature.properties.dataProperties.volume ||
        !feature.properties.dataProperties.volume[type] ||
        !feature.properties.dataProperties.volume[type][layer] ||
        !feature.properties.dataProperties.volume[type][layer].value[val_type]
      )
        return null;
      return feature.properties.dataProperties.volume[type][layer].value[
        val_type
      ].toFixed(1);
    },
    goto_ebs(tab) {
      let action = (value) => {
        let centroid = turf.centroid(this.selected_feature);
        if (centroid)
          centroid = {
            lng: centroid.geometry.coordinates[0],
            lat: centroid.geometry.coordinates[1],
          };

        window.open(
          process.env.VUE_APP_EBS_FRONTEND +
            "/callback/" +
            base64.encode(
              JSON.stringify({
                ...value,
                active_tab: tab,
                name: this.selected_feature.properties.name,
                organization: this.container.organization,
                centroid,
              })
            ),
          "_blank"
        );
      };
      if (this.selected_feature) {
        if (
          this.selected_feature.properties.element &&
          _.isObject(this.selected_feature.properties.element)
        ) {
          action(this.selected_feature.properties.element);
        } else if (_.isString(this.selected_feature.properties.element)) {
          new APIService()
            .get_element({ url: this.selected_feature.properties.element })
            .then((res) => {
              action(res.data.element);
            })
            .catch((err) => {
              this.handleErrors(err);
            });
        }
      }
    },
    get_ebs_data() {
      if (
        this.selected_feature.properties.element &&
        _.isObject(this.selected_feature.properties.element)
      ) {
        this.is_loading = true;
        Promise.all([
          this.apiService.get_vault_metrics({
            query: `element=${this.selected_feature.properties.element.uid}`,
          }),
          this.apiService.get_tickets_metrics({
            query: `element=${this.selected_feature.properties.element.uid}`,
          }),
        ])
          .then((res) => {
            this.is_loading = false;
            // vault
            this.vault_count =
              (res[0].data.file ? res[0].data.file.count : 0) +
              (res[0].data.folder ? res[0].data.folder.count : 0);
            // tickets
            this.tickets_count =
              (res[1].data.assigned || 0) +
              (res[1].data.owner || 0) +
              (res[1].data.member || 0);
          })
          .catch((err) => {
            this.is_loading = false;
            this.vault_count = 0;
            this.tickets_count = 0;
            this.handleErrors(err);
          });
      } else {
        this.is_loading = false;
        this.vault_count = 0;
        this.tickets_count = 0;
      }
    },
  },
};
</script>
<style lang="scss">
.is-centered-text {
  justify-content: center;
}
.table-centered {
  margin: 0 auto;
}
.table-isresponsive {
  display: block;
  width: 100%;
  overflow-x: auto;
}
.ebs {
  z-index: 1;
  font-size: 0.7rem;
  position: fixed;
  right: 3.6rem;
  top: 4rem;
  div a {
    position: relative;
    background: transparent;
    padding: 1rem 0.5rem;
    border-radius: 100px;
  }
  .count {
    position: absolute;
    top: -12px;
    right: -7px;
    background: red;
    border-radius: 100px;
    padding: 2px 8px;
    color: white;
    font-size: smaller;
  }
  img {
    width: 35px;
  }
}
.quick-details {
  font-size: 0.7rem;
  position: fixed;
  right: 1rem;
  bottom: 8rem;
  min-width: 15rem;
  .card {
    border-radius: 10px;
  }
}
</style>
